import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import withAccessControl from 'hoc/withAccessControl';

import { currentUserReducerName } from 'store/current-user/reducer';
import { RootState } from 'store/rootReducer';

import NewConsentForm from './NewConsentForm.layout';
import { NewConsentFormOwnProps, NewConsentFormStateProps } from './NewConsentForm.types';


const mapStateToProps = (state: RootState): NewConsentFormStateProps => ({
    accounts: state[currentUserReducerName].accounts,
    //
});


const decorate = compose<ComponentType<NewConsentFormOwnProps>>(
    withTranslation('consent'),
    withAccessControl,
    connect(mapStateToProps),
);

export default decorate(NewConsentForm);
